// Core imports
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { EnergyProgramComponent } from './forms/energy-program/energy-program.component';
import { AppRoutingModule } from './/app-routing.module';
import { HomeComponent } from './home/home.component';
import { TemplateComponent } from './shared/template/template.component';
import { EfficiencyAwardsComponent } from './forms/efficiency-awards/efficiency-awards.component';
import { RequestInformationComponent } from './forms/request-information/request-information.component';
import { TaxApplicationComponent } from './forms/tax-application/tax-application.component';
import { VideoSurveyComponent } from './forms/video-survey/video-survey.component';
import { ProviderComponent } from './forms/video-survey/provider/provider.component';
import { FranchiseComponent } from './forms/video-survey/franchise/franchise.component';
import { ArmccmService } from './forms/armccm/armccm.service';
import { ArmccmComponent } from './forms/armccm/armccm.component';
import { LeoService } from './forms/leo/leo.service';
import { LeoComponent } from './forms/leo/leo.component';
import { CoreService } from '../core/core.service';
import { EnergyEfficiencyService } from './forms/efficiency-awards/efficiency-awards.service';
import { TaxService } from './forms/tax-application/tax-application.service';
import { EnergyProgramService } from './forms/energy-program/energy-program.service';
import { FranchiseService } from './forms/video-survey/franchise/franchise.service';
// import { RedirectComponent } from './forms/redirect/redirect.component';
import { ComplaintsComponent } from './forms/complaints/complaints.component';
import { NgxMaskModule } from 'ngx-mask';
import { CurrencyMaskModule } from 'ng2-currency-mask';



@NgModule({
  declarations: [
    AppComponent,
    EnergyProgramComponent,
    HomeComponent,
    TemplateComponent,
    EfficiencyAwardsComponent,
    RequestInformationComponent,
    TaxApplicationComponent,
    VideoSurveyComponent,
    ProviderComponent,
    FranchiseComponent,
    ArmccmComponent,
    LeoComponent,
   // RedirectComponent,
    ComplaintsComponent


  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule ,
    CurrencyMaskModule
  ],
  providers: [
    ArmccmService,
    LeoService,
    EnergyEfficiencyService,
    TaxService,
    EnergyProgramService ,
    FranchiseService,
    CoreService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
